export default "__VITE_ASSET__DQkcFQww__"